import _ from 'lodash';
import {connect} from 'react-redux';
import createSelector from 'helpers/createSelector';
import moment from 'moment';
import {LatestFeedList} from 'modules/feed';

export default connect(
  createSelector(
    (state, props) => ({
      model: _.get(state, 'home.first.feed'),
      panel_row2: _.get(state, 'subject.panel_row2'),
      query: _.get(state, 'router.location.query'),
      subjects: _.get(state, 'subject.entities'),
      mediaTypes: _.get(state, 'mediaType.mediaTypeById'),
      mediaTypeIds: _.get(state, 'mediaType.mediaTypeIds'),
      sourceGroup: _.get(state, 'sourceGroup.entities'),
      checkMediaType: _.get(state, 'home.mediaType')
    })
  ,
    (state) => {
      const {panel_row2, checkMediaType} = state;
      const subjectId = _.get(panel_row2, 'data[0]')
      const subject = state.subjects[subjectId] || {};
      const mediaTypes = _.keys(_.get(subject, 'queries'));
      const model = state.model;
      const renderMediaType = ['facebook', 'video']
      return {
        model,
        showAppend: true,
        query: {
          ...state.query,
          subjectId: subjectId,
          mediaType: checkMediaType || _.head(mediaTypes),
          limit: _.includes(renderMediaType, checkMediaType) ? 6 : 5,
          startDate: moment().subtract(6, 'd').format("YYYY-MM-DD 00:00:00"),
          endDate: moment().format("YYYY-MM-DD 23:59:59"),
        },
      };
    }
  ),
  () => ({})
)(LatestFeedList);



/** WEBPACK FOOTER **
 ** ./src/app/modules/home/components/FeedListContainer.js
 **/